const deceasedSuppressionPageData = {
  slug: "deceased-suppression",
  title: "Deceased Suppression",
  introduction:
    "Use our deceased files to remove data belonging to individuals who have passed away, protecting your brand reputation and reducing costs by ensuring your marketing reaches active customers and prospects.",
  hero: {
    eyebrow: "Suppression Services",
    align: "left",
    // Links to the enquiry form at the bottom of this same page — see enquiryForm.anchorId below.
    cta: { label: "Enquire now", href: "#enquiry" },
  },

  sections: [
    {
      id: "gdpr-legal-requirement",
      variant: "feature",
      tone: "light",
      icon: "warning",
      title: "A Legal Requirement Under GDPR Article 5",
      content: [
        "Deceased suppression is no longer just best practice. GDPR Article 5 requires by law that you keep your data accurate and up-to-date. Non-compliance risks significant regulatory fines, wasted spend, and serious brand reputational damage.",
      ],
    },
    {
      type: "benefits",
      variant: "pillars",
      items: [
        {
          icon: "bell",
          title: "Brand Protection",
          description:
            "Prevent distressing communications from reaching bereaved relatives, safeguarding your reputation",
        },
        {
          icon: "dollar",
          title: "Cost Reduction",
          description:
            "Eliminate wasted marketing spend on unreachable contacts across every channel",
        },
        {
          icon: "shield",
          title: "GDPR Compliance",
          description:
            "Satisfy Article 5 accuracy requirements and reduce risk of regulatory fines",
        },
      ],
    },
    {
      id: "data-methodology",
      title: "Our Data & Methodology",
      titleDivider: true,
      content: [
        "High-quality, verified deceased records — not assumptions or indicators.",
      ],
      highlight: {
        heading: "Accurate & Quality Data — Not Assumptive Indicators",
        content: [
          "Our comprehensive deceased removal tools provide a high-quality, reliable file of confirmed deceased records. The data is curated directly from the bereaved and/or third-party sources of actual recorded deaths. Unlike other providers, we focus strictly on verified, confirmed records — not inferential or assumptive data signals — ensuring your suppression is both precise and trustworthy.",
        ],
      },
    },
    {
      type: "benefits",
      variant: "rows",
      heading: "The Significance of Deceased Suppression",
      titleDivider: true,
      introduction:
        "The consequences of failing to suppress deceased records go beyond compliance.",
      items: [
        {
          title: "Protect your brand.",
          description:
            "Sending communications to the deceased can seriously damage your reputation and cause real distress to relatives — a reputational risk no brand can afford.",
        },
        {
          title: "Increase data accuracy.",
          description:
            "Thorough, up-to-date data enables more informed decision-making across your entire marketing operation and customer base.",
        },
        {
          title: "Increase marketing effectiveness and ROI.",
          description:
            "Ensure you are not wasting resources — budget, time and effort — on contacts who will not and should not receive your marketing communications.",
        },
      ],
    },

    {
      id: "get-in-touch",
      variant: "feature",
      title: "Start Protecting Your Data Today",
      content: [
        "Talk to our team about integrating deceased suppression into your data workflows",
      ],
      cta: { label: "Get in Touch", href: "#enquiry" },
    },
  ],

  pricing: null,

  enquiryForm: {
    enabled: true,
    serviceName: "Deceased Suppression",
    anchorId: "enquiry",
    heading: "Enquire now",
  },

  seo: {
    title: "Deceased Suppression - Lloyd James Data Consultancy",
    description:
      "GDPR Article 5 compliant deceased suppression — remove verified deceased records from your marketing data to protect your brand and reduce wasted spend.",
    keywords:
      "deceased suppression, deceased data removal, GDPR Article 5, data suppression, marketing compliance, brand protection, Lloyd James",
    canonical: "/deceased-suppression/",
  },
};

export default deceasedSuppressionPageData;
